import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Stats from "@/components/site/Stats";
import About from "@/components/site/About";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Brands from "@/components/site/Brands";
import InstallationTypes from "@/components/site/InstallationTypes";
import RealInstallations from "@/components/site/RealInstallations";
import Leadership from "@/components/site/Leadership";
import SavingsCalculator from "@/components/site/SavingsCalculator";
import EnquiryForm from "@/components/site/EnquiryForm";
import ContactMap from "@/components/site/ContactMap";
import Footer from "@/components/site/Footer";
import FloatingCTA from "@/components/site/FloatingCTA";

export default function Landing() {
  return (
    <main data-testid="landing-root" className="relative">
      <Nav />
      <Hero />
      <Stats />
      <About />
      <WhyChooseUs />
      <Brands />
      <InstallationTypes />
      <RealInstallations />
      <Leadership />
      <SavingsCalculator />
      <EnquiryForm />
      <ContactMap />
      <Footer />
      <FloatingCTA />
    </main>
  );
}
